import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 5D2990D5-D3D4-4E8F-AED8-B90CE6164068
 * name battery-charging-wireless-10
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging-wireless-10.svg
 * tags
 * - Battery 
 * - Home Automation 
 */
export const BatteryChargingWireless10Icon = createSvgIcon(<><path d="M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,18.5H4V6H12V18.5Z" /></>, 'BatteryChargingWireless10Icon');
export default BatteryChargingWireless10Icon